import { render, staticRenderFns } from "./EventPreview.vue?vue&type=template&id=4134fee2&scoped=true&lang=pug"
import script from "./EventPreview.vue?vue&type=script&lang=ts"
export * from "./EventPreview.vue?vue&type=script&lang=ts"
import style0 from "./EventPreview.vue?vue&type=style&index=0&id=4134fee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134fee2",
  null
  
)

export default component.exports